/**
 * Determine the input type
 *
 * @param  {mixed} val The input to get the type of
 * @return {string}
 */
export default function getType (val) {
  if (typeof val === 'undefined') return 'undefined';
  if (typeof val === 'object' && !val) return 'null';
  return ({}).toString.call(val).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
